<div class="about-us">
  Kalkülüs Eğitim ve Bilişim Teknolojileri Sanayi ve Ticaret LTD ŞTİ, 2020 yılında kurulan eğitim alanında dijital platformlarda hizmet veren bir  şirkettir.

  Firmamız;  Web ve mobil platformlarda yazılım üretmeyi, çağımızın getirdiklerini kullanıcılara aktarmayı amaçlamaktadır. Geliştirilen uygulamalarımızın tüm Türkiye’de geniş bir kitle tarafından kullanılması ve başta öğrencilerimiz olmak üzere tüm kullanıcılara fayda sağlaması şirketimizin hedefleri arasındadır.

  Yapılan AR-GE çalışmaları ile de hem elimizdeki uygulamaların geliştirilmesi, hem de yeni uygulamalar üretilmesi devam etmektedir.
</div>
